import {SET_SAMPLE} from 'constants/action-types.js';
import {NEW_SEQUENCE} from 'constants/action-types.js';
import {SET_SAMPLES_TO_SAVE} from 'constants/action-types.js';
import {SET_DROPPED_SAMPLES} from 'constants/action-types.js';
import {SET_RECENTLY_ADDED_SOUNDS} from 'constants/action-types.js';

const samplesReducer = (state = {recentlyAddedSounds: [], samplesToSave: []}, action) => {
    switch (action.type) {
    case SET_DROPPED_SAMPLES:
        return {
            ... state,
            droppedSamples: action.payload
        };
    case SET_RECENTLY_ADDED_SOUNDS:
        return {
            ... state,
            recentlyAddedSounds: action.payload
        };
    case NEW_SEQUENCE:
        return {};
    case SET_SAMPLE:
        let newState = Object.assign({}, state);
        newState[action.payload.sampleId] = action.payload.sample;
        return newState;

    case SET_SAMPLES_TO_SAVE:
        return {
            ... state,
            samplesToSave: action.payload
        };
    default:
        return state;
    }
};

export default samplesReducer;
